module.exports = __webpack_public_path__ + "img/logo.f70acba3.png";